import Vue from 'vue';
import { VueQueryPlugin, VueQueryPluginOptions } from '@tanstack/vue-query';

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
      mutations: {
        retry: false,
      },
    },
  },
};
Vue.use(VueQueryPlugin, vueQueryPluginOptions);
